/**
 * Auto-formatage date JJ/MM/AAAA.
 * Tape 15042026 → affiche 15/04/2026.
 * Gère aussi le backspace proprement.
 */
export const formatDateInput = (value, previousValue = '') => {
  // Remove non-digits
  const digits = value.replace(/\D/g, '');
  
  // Limit to 8 digits max
  const limited = digits.slice(0, 8);
  
  // Auto-add slashes
  if (limited.length <= 2) return limited;
  if (limited.length <= 4) return `${limited.slice(0, 2)}/${limited.slice(2)}`;
  return `${limited.slice(0, 2)}/${limited.slice(2, 4)}/${limited.slice(4)}`;
};

/**
 * Composant input date avec auto-slash.
 * Usage: <DateInput value={val} onChange={setVal} placeholder="JJ/MM/AAAA" />
 */
export const handleDateChange = (e, setter, field) => {
  const formatted = formatDateInput(e.target.value);
  if (typeof setter === 'function') {
    if (field) {
      setter(field, formatted);
    } else {
      setter(formatted);
    }
  }
};

/**
 * Iter 103m - Valide strictement une date au format JJ/MM/AAAA.
 * Vérifie :
 *  - Format strict 10 caractères avec slashes
 *  - Jour 1-31, Mois 1-12, Année 1900-année courante+1
 *  - Date réellement existante (ex: refuse 31/02/2020)
 *
 * @param {string} str  La chaîne à valider
 * @param {object} opts { minYear, maxYear, maxInFuture } — par défaut 1900 / 2026 / 0
 * @returns {{ valid: boolean, reason?: string }}
 */
export const validateFrenchBirthDate = (str, opts = {}) => {
  const minYear = opts.minYear || 1900;
  const currentYear = new Date().getFullYear();
  const maxYear = opts.maxYear || currentYear;
  const maxInFuture = opts.maxInFuture || 0;  // jours dans le futur (0 = pas de futur)

  if (!str || typeof str !== 'string') {
    return { valid: false, reason: 'manquante' };
  }
  const trimmed = str.trim();
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(trimmed)) {
    return { valid: false, reason: `format invalide (attendu JJ/MM/AAAA, reçu "${trimmed}")` };
  }
  const [ddStr, mmStr, yyyyStr] = trimmed.split('/');
  const dd = parseInt(ddStr, 10);
  const mm = parseInt(mmStr, 10);
  const yyyy = parseInt(yyyyStr, 10);

  if (dd < 1 || dd > 31) return { valid: false, reason: `jour invalide (${dd})` };
  if (mm < 1 || mm > 12) return { valid: false, reason: `mois invalide (${mm})` };
  if (yyyy < minYear || yyyy > maxYear) {
    return { valid: false, reason: `année invalide (${yyyy}) — doit être entre ${minYear} et ${maxYear}` };
  }

  // Date réellement existante (refuse 31/02, 31/04, etc.)
  const d = new Date(yyyy, mm - 1, dd);
  if (d.getFullYear() !== yyyy || d.getMonth() !== mm - 1 || d.getDate() !== dd) {
    return { valid: false, reason: `date inexistante (${trimmed})` };
  }

  // Pas dans le futur (sauf tolérance explicite)
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + maxInFuture);
  if (d > maxDate) {
    return { valid: false, reason: `date dans le futur (${trimmed})` };
  }

  // Iter 402 — âge invraisemblable (> 110 ans) : bloque les fautes de frappe type 27/11/2196 ou 1890
  const maxAge = opts.maxAge || 110;
  const ageAnnees = (Date.now() - d.getTime()) / (365.25 * 24 * 3600 * 1000);
  if (ageAnnees > maxAge) {
    return { valid: false, reason: `âge invraisemblable (${Math.floor(ageAnnees)} ans) — vérifiez l'année (${yyyy})` };
  }

  return { valid: true };
};
